import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { Image } from '@bd/bdcore-utilities';
import ScheduleModal from '../../ScheduleModal';
import { colors } from '../../../styles';

const styles = css`
  padding: 0 0 45px 0;
  position: relative;
  z-index: 2;
  @media (min-width: 992px) {
    padding: 0 0 120px 0;
  }
  .AreaCard_wrapper {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    @media (min-width: 768px) {
      justify-content: space-between;
    }
  }
  .AreaCard {
    width: calc(100% - 30px);
    margin: 0 0 30px 0;
    @media (min-width: 768px) {
      width: calc(50% - 15px);
    }
    @media (min-width: 1600px) {
      width: calc(25% - 15px);
    }
  }
  .AreaName {
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 1;
    margin: 0 0 15px 0;
  }
  .CommunityListItem {
    margin: 0 0 10px 0;
    padding: 0 0 0 20px;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 10px;
      height: 10px;
      background-color: ${colors.brand2};
      top: 3px;
      left: 0;
    }
  }
  .CommunityListItem_name {
    font-size: 17px;
    line-height: 1;
    color: ${colors.brand1};
    font-weight: 700;
    margin: 0 0 2px 0;
    display: block;
  }
  .CommunityListItem_location {
    font-size: 14px;
    line-height: 1;
    font-weight: 300;
    display: block;
  }
`;


function ScheduleAppointment({ areas, communities }) {
  return (
    <section className={styles}>
      <div className="container">
        <div className="AreaCard_wrapper">
          {
            areas.filter(area => !area.isMetro && !area.default_area).map(submetro => (
              <div className="AreaCard" key={get(submetro, 'name')}>
                <Image
                  src={get(submetro, 'photos[0].contentUrl')}
                  className="w-100 mb-4"
                  width={800}
                  height={450}
                  exact
                  alt={get(submetro, 'photos[0].name', get(submetro, 'photos[0].caption', ''))}
                />
                <h3 className="AreaName">{get(submetro, 'name')} Area</h3>
                <ul className="list-unstyled">
                  {
                    communities.filter(community => community.area === submetro.name && get(community, 'schedule_appointment_link'))
                    .map(community => (
                      <li key={get(community, 'name')} className="CommunityListItem">
                        <ScheduleModal community={community}>
                          <span className="CommunityListItem_name">{get(community, 'name')}</span>
                          <span className="CommunityListItem_location">{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</span>
                        </ScheduleModal>
                      </li>
                    ))
                  }
                </ul>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  );
}

ScheduleAppointment.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    areas: true,
    communities: true,
  },
)(ScheduleAppointment);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ScheduleAppointment.section.js